import axios from 'axios';
import { ladeToken, loescheAuth } from 'core/features/auth/authApi';

/**
 * Axios-Client fuer die Finanzen-API (`/api/finanzen`). nginx leitet `/api/*` an
 * den api-service weiter. Alle Endpunkte sind nutzerbezogen und per JWT
 * geschuetzt; uebertragen werden ausschliesslich verschluesselte Daten
 * (Zero-Knowledge).
 */
const finanzenApi = axios.create({
  baseURL: '/api/finanzen',
  timeout: 30000,
});

finanzenApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

finanzenApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      loescheAuth();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

const data = (response) => response.data;

export const fetchBuchungenApi = () => finanzenApi.get('/buchungen').then(data);
export const createBuchungApi = (dto) => finanzenApi.post('/buchungen', dto).then(data);
export const updateBuchungApi = (uuid, dto) => finanzenApi.put(`/buchungen/${uuid}`, dto).then(data);
export const deleteBuchungApi = (uuid) => finanzenApi.delete(`/buchungen/${uuid}`).then(() => uuid);

// ── Dauerauftraege (wiederkehrende Buchungen) ───────────
export const fetchDauerbuchungenApi = () => finanzenApi.get('/dauerbuchungen').then(data);
export const createDauerbuchungApi = (dto) => finanzenApi.post('/dauerbuchungen', dto).then(data);
export const updateDauerbuchungApi = (uuid, dto) =>
  finanzenApi.put(`/dauerbuchungen/${uuid}`, dto).then(data);
export const deleteDauerbuchungApi = (uuid) =>
  finanzenApi.delete(`/dauerbuchungen/${uuid}`).then(() => uuid);

// ── Benutzerdefinierte Kategorien ───────────────────────
export const fetchKategorienApi = () => finanzenApi.get('/kategorien').then(data);
export const createKategorieApi = (dto) => finanzenApi.post('/kategorien', dto).then(data);
export const deleteKategorieApi = (uuid) => finanzenApi.delete(`/kategorien/${uuid}`).then(() => uuid);

// ── Kontowecker-Mails (Sparkasse; nur Roh-Mails, Verarbeitung im Browser) ──
export const fetchKontoweckerApi = () => finanzenApi.get('/kontowecker/ungelesen').then(data);
export const markiereKontoweckerGelesenApi = (uids) =>
  finanzenApi.post('/kontowecker/gelesen', { uids }).then(data);

export default finanzenApi;
